import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/7c680545/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const InlineNotification = makeShortcode("InlineNotification");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const ArtDirection = makeShortcode("ArtDirection");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Legends summarize the distinguishing visual properties such as colors or texture used in the visualization. A legend or key helps the user build the necessary associations to make sense of the chart.`}</p>
    </PageDescription>
    <InlineNotification mdxType="InlineNotification">
      <p><strong parentName="p">{`Note:`}</strong>{` This guidance is a work in progress. To see our roadmap, make feature requests, or contribute, please go to carbon-charts `}<a parentName="p" {...{
          "href": "https://github.com/carbon-design-system/carbon-charts"
        }}>{`GitHub repository`}</a>{`.`}</p>
    </InlineNotification>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Usage</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Position</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Interactions</AnchorLink>
    </AnchorLinks>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p><strong parentName="p">{`When possible, avoid using a legend and label data representations directly.`}</strong>{` Legends rely on visual association, which can make a chart more difficult to understand.`}</p>
    <p><strong parentName="p">{`Your chart doesn’t need a legend if it only presents one data category.`}</strong>{` Only use a legend if you can’t safely assume there will be enough space to apply labels directly.`}</p>
    <p><strong parentName="p">{`Use clear language and avoid acronyms in legends.`}</strong>{` This also applies to titles and axis labels.`}</p>
    <Row mdxType="Row">
      <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "87.05357142857143%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAACXBIWXMAAAsSAAALEgHS3X78AAAB+klEQVQ4y5VU224TMRDN//8D4iKQeGlpaSsk0ogCUiMoDw19INnNdpOILU2z1yR7tb2n9ji7CVvSUEteT+zxyZmZM26VZYlt47GzbaOlPowxRFGE5XJJU9l5nteg/ztrwDiOYRgGHMeBZVlkh2H4ZJbKt7V5QbFruDydYWWolXMOIQRN9TvLOTbPt4E8CFkBJUmCoigIjHNBh3ttG3HKduayIlADpmmK2WxGuVRhVuP1sYllXOxkuJnrGtDzfdpwgxR9WxfkzckQcaIZikZxKgB1fmV666IoI8sy/Lm9BSsS9K99vOvY5PDqyMRixZBARUlTh6kB7/wEbz9Y9Z/WgK7r0qY5DnH8eaIB35somMDUTTCcRP8UvIqoItAA9Ch/xijE0dmYHF4eGrRe9l18PP9Ntu3MyS8vuAYMU+yfNgBVVwSBzJvIJcNAMhyvGBp0+cr0cXZxQ3svDga0dntTDGSulQr22tdrwLWWdAimDO3wkwZ8tq8v9wYe2l2H7OcHmnXn2w1+Gj7SjD/MoZaAXAWDNb7D1wsVgsDpuU3aHI5cXP6aKsWi0x2R3/feBANrKmWV4suPyd9Vrliqyi3mc/k4BLIYDJzpB4KzAkWeUWrUHmMcURjIVl3IO7z2qwG3PQLEerXveR6Jv5JL0099ykrYu/q12RGP9fQ9Re4mYze+IVEAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Legends bahvior highlight on hover",
            "title": "Legends bahvior highlight on hover",
            "src": "/static/4b1343d55a4e2d7f13259eb1c811758d/c168d/legends-usage-1.png",
            "srcSet": ["/static/4b1343d55a4e2d7f13259eb1c811758d/d6747/legends-usage-1.png 288w", "/static/4b1343d55a4e2d7f13259eb1c811758d/09548/legends-usage-1.png 576w", "/static/4b1343d55a4e2d7f13259eb1c811758d/c168d/legends-usage-1.png 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Remove legends to simplify the chart when only one data category is needed or
  only one color is used.
        </Caption>
      </Column>
      <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "87.05357142857143%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAACXBIWXMAAAsSAAALEgHS3X78AAACTUlEQVQ4y32UzWvUQBjG87cU9ObJQ/WmIKIn8SJ4EHoTLAjVg2hBEexBUUEoQlfroYh6KSIoWnrRQmldV61rF8vS/chm3XW72Y9ks0k2mcxjZrL52q+BJBMy7+953jfvjEApxbgx6du4IbCbbdtQFAXdbheapkFVVei6DsYjDgUhFI57UXfui4wT40AGymazkCQJxWIRuVwO5Up1ZIAP9qGDYGFSWorp4F3exJvPLWyv/kNdMkKwM9ppDEiDBRSPkx0cStRw9HUDc0sVPDj/E3PT21i+vgdDI2OhQQ3bbg1brTZbhivrCg4/q2FD6sXUD0oGHl5K487ZFIyO7cEcOlxDptCzXFVTxYsdFVOJA56u78Kh7Kc4QdCjmd9YuvonrGnUoVfYUOH4Sh0vMzqf9wgd+CHes/7X5OlX97ux1AOHTp+4rxBMrcio654by7LRaDR4K7EOYE/0Yxcu7ODLq0rgMubQV8gWdMzM7sG2wnQZSBRF3laGYbg18wKfXM7gw9PSUNpCtLDNiolb01uol8L2YBBZlj13PNgj3j33A1tvazGHDCoMNujCxV94vyh6KZtOrIZWz3vP73Zw7dhXlHMNqFobbbc7CCGhw6jK7mYLs0c2UUir0V0dzGx33fzpFFbvF5gEupoe68XQYQT6cbnMoZ8SEppVkzvrtCx8X5dx40QSi279xh0mQpTOwf16pjeauOfujpsnk7h9JoX5U9/4tfZcCgEODdzHHA5Co21QzbsHR7INMdPhp86g8NBeHnX+0RE7wB+ETD7C/gOVBQbbzmGl4gAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Legends bahvior highlight on hover",
            "title": "Legends bahvior highlight on hover",
            "src": "/static/7125777c246c55c5dd9086016bc7f846/c168d/legends-usage-2.png",
            "srcSet": ["/static/7125777c246c55c5dd9086016bc7f846/d6747/legends-usage-2.png 288w", "/static/7125777c246c55c5dd9086016bc7f846/09548/legends-usage-2.png 576w", "/static/7125777c246c55c5dd9086016bc7f846/c168d/legends-usage-2.png 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  In-chart labels are ideal for charts with predictable data and ample empty
  space.
        </Caption>
      </Column>
    </Row>
    <h4 {...{
      "id": "color-and-texture"
    }}>{`Color and texture`}</h4>
    <p>{`Chart legends use color as the default distinguishing property for data sets and values. Texture can be used instead of, or in addition to, color to make your chart accessible for users with visual impairment.`}</p>
    <Row mdxType="Row">
      <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "82.36607142857143%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAAAsSAAALEgHS3X78AAABlklEQVQ4y41UXauCQBD1//+P3nrpIXrJoESI3iIiywQJuhFWWpqWVnM9cxlx1W4tjLO77pw587GrUT4ejwddr1eK45gliiL6drxeL2Wt4QMAx3HIdV2W9XrNDrIsKyRNU0qSRNkTMGiZM2B4uVDg+39GcUL3+51+tlvyTyd2BjkcDuwMji75ecjz+VRYQmuyQNhBENRC+BRuWZhhlTZY7vd7Ztlk9J8ogGCI0JAn27aLwlQNymuEXAPE53a7cY4wAIiilAFFw2lTdRsBPc9jDUAkX0KWxG82GzJNUwFDzlGk8p4CKPPVakXT6bQAPR6PNB6PaTQaKU4Mw6DFYqHsMSAMT3mLQANwPp9Tu92mfr/PLPAPxsPhsGADADBeLpcqYDlHAITgUKfToVarRdu8H8/nMzPsdrtkWRaHiU7o9XpcwBrDcqVx9XBrEJ6u62zo500/m81oMBgwK6yxj/lkMuG50tgCKF6gUWVZY4BVGIZKZeFcrqCIVm2Ddw2LXO52O278pkdBqfInsCbjd2e0b5+nT05k/AJ5GtiB4fZy+AAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Legends bahvior highlight on hover",
            "title": "Legends bahvior highlight on hover",
            "src": "/static/af1123f5de7800b8f90fa96134b598a5/c168d/legends-usage-3.png",
            "srcSet": ["/static/af1123f5de7800b8f90fa96134b598a5/d6747/legends-usage-3.png 288w", "/static/af1123f5de7800b8f90fa96134b598a5/09548/legends-usage-3.png 576w", "/static/af1123f5de7800b8f90fa96134b598a5/c168d/legends-usage-3.png 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Texture can improve accessibility. See the accessibility page for all approved
  textures.
        </Caption>
      </Column>
    </Row>
    <h2 {...{
      "id": "position"
    }}>{`Position`}</h2>
    <p>{`The legends are positioned at the `}<inlineCode parentName="p">{`top`}</inlineCode>{` of a chart by default, under the chart’s title. Depending on the page’s layout and context, you may choose to position the legends at the `}<inlineCode parentName="p">{`bottom`}</inlineCode>{`, `}<inlineCode parentName="p">{`left`}</inlineCode>{` or `}<inlineCode parentName="p">{`right`}</inlineCode>{` of a chart with respect to the `}<a parentName="p" {...{
        "href": "./chart-anatomy"
      }}>{`graph frame`}</a>{`.`}</p>
    <h4 {...{
      "id": "top-default-and-bottom"
    }}>{`Top (default) and bottom`}</h4>
    <p>{`Position the legend at the top or bottom of a chart in situations where space is a scarce, such as a dashboard.`}</p>
    <Row mdxType="Row">
      <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAAC2ElEQVQ4y4VUTUgUYRgeCArqEBGBlwg6dejULToVBEGIkXXwkIIGaUQiSBQUdMl+wIOmUh7Ci6V0siALcYVdMTOi3SJzV50t3XFbXXd1dmbn55vZp+/bmdlmnElf+Bi+mXee93me9/0+DjRKpRK2C/Z9p+Xkce5NUZEhSRJkWaZLgkKXaW5fzF2URQWQ6AZmvy0gkUiAX1xEfIFHLM5DKcowDRPrhQIUXYeaE6GrGohBQAiBYRjBDHXFxO/vlJWigKgK1mSC2KoBeSOPoiRjen4eK+s5pKdmkctkIVH2oiiWFXkAgzxk2xKtDpj/l2juINltsGm/S/9M4vODQYyeb0f/hWF0NsYxPrAMRSLl76axQ1MYNdO0Si+8CmGgqhb9+6vx9sxNDDW/w91zMdRXhXDr1CfwUdHDNJChSQ1mMTM+je49Z/Hh0n0UljIeaYtfRdw5PYPmYxEICeofaGOI6ffQkblOTd7X2IQbtzsqIKwQY866zULK62g9MYUndTEoqlzutE8ysV/2jY2Bq63F5FKyvDeI4WFINCs/PJTGlaoJpObkip8eyboNWNfTg4MtLbScBaCqKgRBQDabRTKZhKbqVsN4GVePhhEZTnsaVJFM7GZc7OrC4dbWCiOdjg8D4nkeqVSKyrPy1gQF149PYuxFygvotN1h2DY4iF0NDdgoKhVfNE1DgZ4UdjLsuvg1nUf9oRCi49lgyYadGZ6Lg6upRvfom/Jeox46M8z+cX582LuMa3R8pKxmj48NuHWoWdR09WHvvRFEhOCL4XlUBvdoBb0frVkkrguEcyc6o7OhAidfboJ7vIK20CYiyxqiGR3veQWXR3LgOgQ0jeZ915sH8J9061nQDLRPbOJA9x/KRsDuzjQtkMaRZxk8/SL5SPgAg0BZrMoGwpTh6x8iwkkRMnGdrC1ggYDOR5ZseC5XNgWk4lkpAMwHuJWpw4IBM2xrlXzF3fEXyEHTn/fDilYAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Legends bahvior highlight on hover",
            "title": "Legends bahvior highlight on hover",
            "src": "/static/fc51bbf18e96ac75f8417504eee824a1/c168d/legends-pos-1.png",
            "srcSet": ["/static/fc51bbf18e96ac75f8417504eee824a1/d6747/legends-pos-1.png 288w", "/static/fc51bbf18e96ac75f8417504eee824a1/09548/legends-pos-1.png 576w", "/static/fc51bbf18e96ac75f8417504eee824a1/c168d/legends-pos-1.png 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAAC0ElEQVQ4y5VV20sUURgf6C2ioIcieomeeq236A/I6Ib6lkkbmexTgg/Sm6R0EyIoBBGXgujBByUwtYxubCqarmFRsOxlBneWbdO9zP3+68zZmdkd80IffHwz55z5fb/vfJdhQMRxHOwku+03CuMfdq0kSRBFMbCu2rbtbtJ9X3dyEgC6H3Ich0wmA5Zl6TNHrCYrdaa2A8t0qPVBNwMz23pzdg7btpwt90Ihuyx9NclaMclh6e5LTJ3rxvD5Fxho/4XpIQ5SxQhAN18DE/LigbqSGf2EZ4dbMXzgIiabujHeNYW+5u+IHP2IrlNz+Dlb9r4Ls2TCYdTA5uNLeLz3LN629ELM/QmFyicl3LmwjBvHPiPzTSArJkzTqjMMkuJZQVWxv7MT13r6GhxZlLnlOdRVCz1nFtB/KUErwrKscMjug+ktPo/HwbS04H0qSd99776YRs3x18ki2g59QDohhpIUMDQ8wJsjI9jX0UFZuaJpGnieR6lUQiqVgqZqdH09pyJ6Io6Z2FooQXVA06T2yuAgDkajdUZkPZvNIp1OI5fLkTqsOSoXddw6OYeJp1yYoR+yz7B3fBxM21Xky5Xgbg3DgCzL9K68IgCfqCJCQl58Xdw6ZMs7ucJyYJovo39stJYAAuKedU+51v9wIJbH9dMLqBY0r9MaAH31M90+HMOe22OYZu0t+zW2KoN5kMejWcEjUy9uprGjfEBSFWgaE8Hc59HxpoJ3rIZEwcBESkXrqxKYezwik+WgO7dtPdr8lLoD3bTR+0XAkcECYcODeZinenyogCfLUtDwdtAqm+pwu7lQ0YHFgoWZjIZ5ToK+y8ysl41mg/0hkMqXoSkyfldVrJALt1TCxtaRXMtCEDZQWU2jtF6GrCi0SxRiQ8MhyDKZcxt5FSppPV1TISgGeMEk7wpRHdz6BqqKCnGtCFmUaMG7Z137z7T5nxG/22/iL/aN04EWGPCSAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Legends bahvior highlight on hover",
            "title": "Legends bahvior highlight on hover",
            "src": "/static/3f1a2db2f4479e734581b7bf7f7e377d/c168d/legends-pos-2.png",
            "srcSet": ["/static/3f1a2db2f4479e734581b7bf7f7e377d/d6747/legends-pos-2.png 288w", "/static/3f1a2db2f4479e734581b7bf7f7e377d/09548/legends-pos-2.png 576w", "/static/3f1a2db2f4479e734581b7bf7f7e377d/c168d/legends-pos-2.png 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h4 {...{
      "id": "right"
    }}>{`Right`}</h4>
    <p>{`Position the legend to the right of the chart when space is plentiful, or when you would like to provide the maximum context.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAACi0lEQVQ4y6VUz28SQRTe/0LjxWsTjx69NjEe9NiD3oxHTVATe/HUeMCoF2MTJbEH68lIojHViD+IMbEUQimNSCkiICz7E9gFXJbdHT53BpDdFkpNX/KS2Zn3vv3eN/Me1+/3McupedcHGYdDmBd0JiANMk0TlmXBtm3mhBD2Td1xnEODMUCaHI/HEY1GkclkEIvFkEqlsJlMYv3bOtLp7X0lHyQLK5mCjpg5lsvS9bEREMdNIjRpuo6jfc4b0Ov1oOgN0CJbv3jw3xU05TH4ABSwHQuCVEWhUEClUvHJwo0oU3bUxHgWr87ewotTl/DwXBg3zqSwcjOLnuEM2BIHf1oWdjYFyIqMdqvtY8l56RZrIh6fvoKNxRA6YgOWaYPf7SC4sIW7C2kosoqmrkIudfHlmQBVVaDrOrs8X8l0g9p8MIjFJysTNbo9n0DkaZWtTbsP3a2o2WhAUVVomuYHbLkbuVIZx69ew7bAoyHLqFaqkCQJiY0kTKIj+lxkTKnlVRvLyS40F1AQBIhuHAUdPJsh8u96nQHWNB01nkc+n2ei7+bysGEg8VrB0vkki82KIu68j6DlljvSft8tW+5NnQwE8DL21T11wIsSJMXVS66z89WlAkKBH2wt/KziQyiMukui3W6z1+G7ZdsZ/OXe2lvMBcNQLb9+a8Ue5u7zKJQM9t2VNEift8DXaiiXy0wa+o7/9bL3tV+PdnBiWUTgk4YH8TYuvmni2CMRqztddu4443drGAZj2Ol0xoC+xh+uI0UTl99puBBWEfjYRK4+CCbE03pD7fZ2C7d3mhBvaxlNkJYyYEb6nsTp/cxNGlE02fa49yezpg43ffbRUfB/s3DqgJ00pY8EeBT7Cz7m8WWozG3GAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Legends bahvior highlight on hover",
              "title": "Legends bahvior highlight on hover",
              "src": "/static/2b732d14559eeb23099f56fe8cbc30e9/09548/legends-pos-3sm.png",
              "srcSet": ["/static/2b732d14559eeb23099f56fe8cbc30e9/d6747/legends-pos-3sm.png 288w", "/static/2b732d14559eeb23099f56fe8cbc30e9/09548/legends-pos-3sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.690789473684205%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABmUlEQVQoz32STUvDQBCG+8d68Bd4EATxpOJJvGjuPXjRg0g9FEWv1osiKFRBqqj1YAUpVNEmKNpobZua9MOmJcnu62bzYdJUhywzTCZP9p2ZGFyjlGLQKKEg7HjvbG+Hjg8fz2LBhKqqkGUZ1con6g0lBLfBHIroj4MWAhqGAb3XQw8WtEoNb2dFiPmmj+BQ9qgNFe12O6TM87FffZRLtE3eu8JBfB7ZuQ2szz5gebyAD/Gbv+v3KSSpg2ZTY3E/0i4faBHCfU4SIUwI0B/f/aKbwzqWRu/Q0brQTRPZgsSATfSYGuJ+59/Qk+wBJ1MprF2e89iWpX5pPN5efML1fo3HilTmMPvYbRoKJG5iLJnEabHIGkZRkiSI4jPPH6284GSzPHQQEcl2wrQsnhDSaSzs7LiVll+YEEq4v1Cd9pgksjKhG/IJul5pqYhv5bF6q6PaJXhtWZjKaJjJaH5deC/DaxQL0i1vymyg08caRnbr7ChI5DowCB26JpE9HOyDA3VivW/AZFMdrPkLFgEG5Xu39X7yn8yg/QAlzpVl1B/RdwAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Legends bahvior highlight on hover",
              "title": "Legends bahvior highlight on hover",
              "src": "/static/875b91acd6b6803a63296902dee5a831/fb070/legends-pos-3.png",
              "srcSet": ["/static/875b91acd6b6803a63296902dee5a831/d6747/legends-pos-3.png 288w", "/static/875b91acd6b6803a63296902dee5a831/09548/legends-pos-3.png 576w", "/static/875b91acd6b6803a63296902dee5a831/fb070/legends-pos-3.png 1152w", "/static/875b91acd6b6803a63296902dee5a831/fb755/legends-pos-3.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.690789473684205%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABmUlEQVQoz32STUvDQBCG+8d68Bd4EATxpOJJvGjuPXjRg0g9FEWv1osiKFRBqqj1YAUpVNEmKNpobZua9MOmJcnu62bzYdJUhywzTCZP9p2ZGFyjlGLQKKEg7HjvbG+Hjg8fz2LBhKqqkGUZ1con6g0lBLfBHIroj4MWAhqGAb3XQw8WtEoNb2dFiPmmj+BQ9qgNFe12O6TM87FffZRLtE3eu8JBfB7ZuQ2szz5gebyAD/Gbv+v3KSSpg2ZTY3E/0i4faBHCfU4SIUwI0B/f/aKbwzqWRu/Q0brQTRPZgsSATfSYGuJ+59/Qk+wBJ1MprF2e89iWpX5pPN5efML1fo3HilTmMPvYbRoKJG5iLJnEabHIGkZRkiSI4jPPH6284GSzPHQQEcl2wrQsnhDSaSzs7LiVll+YEEq4v1Cd9pgksjKhG/IJul5pqYhv5bF6q6PaJXhtWZjKaJjJaH5deC/DaxQL0i1vymyg08caRnbr7ChI5DowCB26JpE9HOyDA3VivW/AZFMdrPkLFgEG5Xu39X7yn8yg/QAlzpVl1B/RdwAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Legends bahvior highlight on hover",
              "title": "Legends bahvior highlight on hover",
              "src": "/static/875b91acd6b6803a63296902dee5a831/fb070/legends-pos-3.png",
              "srcSet": ["/static/875b91acd6b6803a63296902dee5a831/d6747/legends-pos-3.png 288w", "/static/875b91acd6b6803a63296902dee5a831/09548/legends-pos-3.png 576w", "/static/875b91acd6b6803a63296902dee5a831/fb070/legends-pos-3.png 1152w", "/static/875b91acd6b6803a63296902dee5a831/fb755/legends-pos-3.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <h4 {...{
      "id": "left"
    }}>{`Left`}</h4>
    <p>{`Position the legend on the left of the chart when better type alignment is needed. Be sure the surrounding elements of the chart are not too closely clustered.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAACl0lEQVQ4y5VUXYsSURiefxFdBFHQXT+g/kEIsTddehcE0ceuN9VlsFFQQlS2UXdBFBtdhAVbu3ixBLrW6mZuqBWrMo4zzoyps+p8P51zHHdGdzf1hXc8R855zvO8X5zrupjk1ILr/xmHKSwIOhGQHtJ1HaZpwrIs5o7jsD1127anBmOA9HI6nUYikUA+n0cqlUI2m0Umk2HrXC7HDtJzTDb5dRyX+UHMuXFZlCFlRgEoO7oPaB9h49j0AfqfD84A5WYd5XIZlUoF3W53nwxDNyA2FVDx2o4A/ocEtW747zg+U46+UvgmoS5IaLdbhJUzklXKlD26VcL70C0snw4jdu4NFs5m8PzaNnqazRiaxkAJZ+oOPi/VUOdlBjiUGwxDTVGxdOYSkvMxaIICS7dQ/9NFNPwdd+a2IEsqJEkcMKSfFqHc7nSgqirzYdwMAk4tFI3iyuNnB2b1dmgT8UcVtrYtAqiTz71kD6Lahtwg0kURiqKw1zqEcYnE9tj1eWyUd6BrGkrFEprNJjaSX2G4HXx5K+Huhawfwx5hcSMehyDLsDxGwdhVCePjCxH8lhpQGw0UikWWwGKhhL6tIbuiYnEu42fZJBn88PAVJKHOZPf7/X21dSISwcv1NVooECQZkqyg0VDZfvl+GbHL23tlxDmmBenTJkReQKVaBc/zMIxBSVhelzxdW8XJxdeo9Ufjl+BNnHpQw89fXa/4Xb+wafvt7u6iQ1gOAZl0j+nN9S6OxkRcXW0hmtYQ/vgXR56IeJHvDRJCO2fYy45Xe4cNhOE6UdFxcaWF8+8UAtxEXrb2mLleJ3HjF8dH1jhTZv02XE3xmQXOcbOMLnrZCrjttRzcsV6ebiZ6F1mjHT4jZwCcHJqZAKe1f2bJ8XSG0JE3AAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Legends bahvior highlight on hover",
              "title": "Legends bahvior highlight on hover",
              "src": "/static/22db7b10758cfb024546fe29fe7eb1e7/09548/legends-pos-4sm.png",
              "srcSet": ["/static/22db7b10758cfb024546fe29fe7eb1e7/d6747/legends-pos-4sm.png 288w", "/static/22db7b10758cfb024546fe29fe7eb1e7/09548/legends-pos-4sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.690789473684205%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABlElEQVQoz31STU/CQBDlX3nF+Ac0US/evJmYePPkBTXgzTMeNPFiSIjBq5hoYvSkQVE0FlAKSSu4LSCtLaXb59IvKKVMstnd2TdvZ+ZNDK5ZloVp5vmHu72o5Z9H/hE+Nv5ICEGNr0EQBNTrdciyPAqiNPARNa3QZyFCmUgQRRG6rkPTNBiG4QSz9yFdv6eAlFvoEmNqBSHCBq+zLDuM7M8PMN3MyieXyMU3kV07xt7SCzL7Fbv8yXYFCK/feDTEJvq6BsqITNO0/bnbexwub0OviM4nfQtHW+843flgtwHDRpX82UCv0/VLHvopI40nk8hXORujKCoMqtlCHKw+QagoTlvcbGNRKnt3QZIwzwhlRtSR2+A4DtUqb7+lN0oo3ki+SKEM/dGwgqOxkEoh//xon1VVdcumSKy/ovXl9NvrZyThuCAXhSLm0g8otMDKBZoqxUpOxu5V28WxGE8URNgkaZYbIH72g8VzwnaCxN1vAOuLMpPQBdGxoS59s15qAw8UnkPMMF8otps0KJpJJ1rl+v8BazSVknNL8NYAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Legends bahvior highlight on hover",
              "title": "Legends bahvior highlight on hover",
              "src": "/static/d353f2210ca74a9a56152de221fcd756/fb070/legends-pos-4.png",
              "srcSet": ["/static/d353f2210ca74a9a56152de221fcd756/d6747/legends-pos-4.png 288w", "/static/d353f2210ca74a9a56152de221fcd756/09548/legends-pos-4.png 576w", "/static/d353f2210ca74a9a56152de221fcd756/fb070/legends-pos-4.png 1152w", "/static/d353f2210ca74a9a56152de221fcd756/fb755/legends-pos-4.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.690789473684205%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABlElEQVQoz31STU/CQBDlX3nF+Ac0US/evJmYePPkBTXgzTMeNPFiSIjBq5hoYvSkQVE0FlAKSSu4LSCtLaXb59IvKKVMstnd2TdvZ+ZNDK5ZloVp5vmHu72o5Z9H/hE+Nv5ICEGNr0EQBNTrdciyPAqiNPARNa3QZyFCmUgQRRG6rkPTNBiG4QSz9yFdv6eAlFvoEmNqBSHCBq+zLDuM7M8PMN3MyieXyMU3kV07xt7SCzL7Fbv8yXYFCK/feDTEJvq6BsqITNO0/bnbexwub0OviM4nfQtHW+843flgtwHDRpX82UCv0/VLHvopI40nk8hXORujKCoMqtlCHKw+QagoTlvcbGNRKnt3QZIwzwhlRtSR2+A4DtUqb7+lN0oo3ki+SKEM/dGwgqOxkEoh//xon1VVdcumSKy/ovXl9NvrZyThuCAXhSLm0g8otMDKBZoqxUpOxu5V28WxGE8URNgkaZYbIH72g8VzwnaCxN1vAOuLMpPQBdGxoS59s15qAw8UnkPMMF8otps0KJpJJ1rl+v8BazSVknNL8NYAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Legends bahvior highlight on hover",
              "title": "Legends bahvior highlight on hover",
              "src": "/static/d353f2210ca74a9a56152de221fcd756/fb070/legends-pos-4.png",
              "srcSet": ["/static/d353f2210ca74a9a56152de221fcd756/d6747/legends-pos-4.png 288w", "/static/d353f2210ca74a9a56152de221fcd756/09548/legends-pos-4.png 576w", "/static/d353f2210ca74a9a56152de221fcd756/fb070/legends-pos-4.png 1152w", "/static/d353f2210ca74a9a56152de221fcd756/fb755/legends-pos-4.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <h4 {...{
      "id": "overlay-geospatial-only"
    }}>{`Overlay (geospatial only)`}</h4>
    <p>{`In geospatial charts, legends can be overlayed on top of a graph frame.`}</p>
    <Row mdxType="Row">
      <Column colLg={12} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAACs0lEQVQ4y62U227TQBCG8xhc8g48AQ/BS6AKob5D4bp3XHCB1EogBAhBryhFLZFIRENU2qoHWqenNKkb2/FpfYgPP/uva5OkRSCBpfGud+zPM//Mbg3/eOV5PjGv8TYcDmFZljLHcWDbNkzThBBCGf2u6yrzPE+ZruuIokiBOGZZpuYK2Gg0sPR+Cc1mE/V6Haurq1hZWUG73cbW5qaa08dnvst3uGYYhoLwB0mSlED816vGm3UWor/nIh4FiMIQQlmM44GL7mCILE2QpplKK01ThNLPiGicM8s4jgsNCWx+tvHuZQ/GUMdRV8fhWR8n/QF2DzScnhwrEG00GilN+SHn1M73fQXlvAK+2jcx1zjH984F6rtdbGjnMjoHB8enCCSAVyl6GEYYyWgIZvEIKqOtgEtfGnj8/DVaJw4+bHfxdacDL84QpASliCSAKecydV/IassixBLEKGnXgL1PG9hbXMZWz0TrUEfnwkNbu8DOUReWbB9N02Aal7gMYmy3fiB0XCRSS0ZHY8oEF31Iovx7p9vDg4UFPFxcxOyLt1g7PEcmndlVG8R+gqdrFtZbB3AHBjypHfULgkABq6KUHxi+h3vz87g1M4O7j+YwcJ0r7Qq/bYToaTaSLIItm79sco5lhFXbjG8fV/6VrQNVhFxFmEtoEAqpZSAjClVBGB1HpsyR8GrrldCU7cE+CwQGtgdLxJXP94XclsX2EzJNAtiTZW8ydc4ngDSVYTbC7EcTt5/omG/5hV9JnUFQN79Iczw7QqsqT0IL3XpDgTvPdNxfLrRMr7T0RIijS0dmEVS9OS5ZbfoYUlBVjQjrZz7cOJ8AfuvHeLMfTKyV2VUR3nS2eVIzZMmv9TK1qfNvPJCJCKdfoPjcIflU9OPS/BF4/aP8xlO5eM5vzKz2O9jfrk37fwKYsQGGzyofgQAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Legends bahvior highlight on hover",
              "title": "Legends bahvior highlight on hover",
              "src": "/static/999bbd93291b18ddf68324168cf5cab6/09548/legends-pos-5sm.png",
              "srcSet": ["/static/999bbd93291b18ddf68324168cf5cab6/d6747/legends-pos-5sm.png 288w", "/static/999bbd93291b18ddf68324168cf5cab6/09548/legends-pos-5sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "62.5%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAAB5klEQVQ4y22TPW8UMRCG/VMoKGkpKPgH6fkLSElLR4NIi1AqRBFRRGkCAlFCihQIhBQpFEkRRQjywaHc7t5e7rLrb/vFY8eL75SRRrP2jh+P37GZlBJKqej0rY1Bad6T+2LsBydzzsFaO4xZdVmhrms0zQRViKLv4o+qt5DGEWIBVILJTChACBHBEXjyu0V3PYOSKk6Mucf3kcLWUYe2C4nWxArIaREB6DvHDMqbsPPzUQDOcVm3WPtU49HHBi/3r3E61YANcmgD59OxsjRa6+hKpVhWzOIgVDGedrjzeoK7b3psHEh8vRDhR4CFI4uuB+940FcPMHJjddyMVPE30rBcsnEW956/AlvdwIPNIxzWNs7/aQ1290fgkylUOKbKTdQK3UxAS7egMculUlx/v4OHz57i28lx6mDYtRkLVA0PABnFJ0/HDsArBaNvAZbdI7PWD93VJixWBEuVZS0FF8Mxy/Ws7JC26ZpsH86x8m6Cs5mNY00gJSIs5tLdI217DussfNnlssIc217jyd4UF/MEaLnBwV9OpOGaXP0c4e39x/jxYietDcVEYAnK0RodFczWax8u+o1WLuXIdo7jrc/49eHLUPUAXH4J9PwsJQC3vo5lzct5hiX7/3MxcRkW5+iYbjHnH0DF6rnVwbClAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Legends bahvior highlight on hover",
              "title": "Legends bahvior highlight on hover",
              "src": "/static/9d9b1a419a80f0e25f817136d042cb28/fb070/legends-pos-5.png",
              "srcSet": ["/static/9d9b1a419a80f0e25f817136d042cb28/d6747/legends-pos-5.png 288w", "/static/9d9b1a419a80f0e25f817136d042cb28/09548/legends-pos-5.png 576w", "/static/9d9b1a419a80f0e25f817136d042cb28/fb070/legends-pos-5.png 1152w", "/static/9d9b1a419a80f0e25f817136d042cb28/fb104/legends-pos-5.png 1728w", "/static/9d9b1a419a80f0e25f817136d042cb28/cf416/legends-pos-5.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "62.5%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAAB5klEQVQ4y22TPW8UMRCG/VMoKGkpKPgH6fkLSElLR4NIi1AqRBFRRGkCAlFCihQIhBQpFEkRRQjywaHc7t5e7rLrb/vFY8eL75SRRrP2jh+P37GZlBJKqej0rY1Bad6T+2LsBydzzsFaO4xZdVmhrms0zQRViKLv4o+qt5DGEWIBVILJTChACBHBEXjyu0V3PYOSKk6Mucf3kcLWUYe2C4nWxArIaREB6DvHDMqbsPPzUQDOcVm3WPtU49HHBi/3r3E61YANcmgD59OxsjRa6+hKpVhWzOIgVDGedrjzeoK7b3psHEh8vRDhR4CFI4uuB+940FcPMHJjddyMVPE30rBcsnEW956/AlvdwIPNIxzWNs7/aQ1290fgkylUOKbKTdQK3UxAS7egMculUlx/v4OHz57i28lx6mDYtRkLVA0PABnFJ0/HDsArBaNvAZbdI7PWD93VJixWBEuVZS0FF8Mxy/Ws7JC26ZpsH86x8m6Cs5mNY00gJSIs5tLdI217DussfNnlssIc217jyd4UF/MEaLnBwV9OpOGaXP0c4e39x/jxYietDcVEYAnK0RodFczWax8u+o1WLuXIdo7jrc/49eHLUPUAXH4J9PwsJQC3vo5lzct5hiX7/3MxcRkW5+iYbjHnH0DF6rnVwbClAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Legends bahvior highlight on hover",
              "title": "Legends bahvior highlight on hover",
              "src": "/static/9d9b1a419a80f0e25f817136d042cb28/fb070/legends-pos-5.png",
              "srcSet": ["/static/9d9b1a419a80f0e25f817136d042cb28/d6747/legends-pos-5.png 288w", "/static/9d9b1a419a80f0e25f817136d042cb28/09548/legends-pos-5.png 576w", "/static/9d9b1a419a80f0e25f817136d042cb28/fb070/legends-pos-5.png 1152w", "/static/9d9b1a419a80f0e25f817136d042cb28/fb104/legends-pos-5.png 1728w", "/static/9d9b1a419a80f0e25f817136d042cb28/cf416/legends-pos-5.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <h2 {...{
      "id": "interactions"
    }}>{`Interactions`}</h2>
    <h4 {...{
      "id": "hover-to-highlight"
    }}>{`Hover to highlight`}</h4>
    <p>{`Hovering over the legend of one category lowers the opacity of all other categories in the chart to 30 percent.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAACeUlEQVQ4y51UyW7bQAz17/cv+gG59tJTEbSHxEAbwM6+VggsW8toGS2jkUavJGPZkuOgRQ2MRXE4T4/k48z6vsf//D46N+O/prGoyhpFUcgqyxJVVSFJM7GNMeLXtNIsh7V2B3oILIAqjbC8usDZ2Rnm83Mslks83t3g/Ps3LBZL3N3d4tfFBa6vLrH4OUeaph+yFMDXmxKXPyIYy8xqdE2FB9Xi63ONptQo2WcNnoMcJ/MXqDgl5sWE5QAugL+XGovTELpMkSQUnCW4Dg2+PFRiK/JVBcU8ePj0+QSe94ose8+S7Vnv9o7Wtn9tRpHEO9s5d4whvbi3Fccx8jyXTUfvbed2h/jJa2AifvR7e5xyXdcIggCDPRwUBVQObbMFQj9h5LbZvashg3ieJw6WiwT3DmuVkVQMXNejqTsC7rYHe5JOB1N1sLWDNd0UUGuNp6enHaB0PlF4DRO8BJGAczwzZWBhZacinwCyeH3fJzYaOs0RKg1fpUwEsS4Q0QelCQTMbAvdwI9SbLIM9+s11brbd5kNngQGbNsWiibhJQypdpSOYWYOXhRNOn3vbRDSh2vbIKOMVkkyBeSxGlJ+9DcIdImW+lBSzYgQNnmBxyCGTyC364D2K3A/emENAbRblruUB0BNE9C5XgIdfdG0Tg6atkNclMhqI3GWJGVaao6DxLhxDTllpdSbbCgF0dVoiYxGEzER9EiDb5MyCmRRh1S/4Ybh7o9tRamxxHjxBcGK4L0813RjNXuGAygfZoHrbVc5qNvWhp+DpAapDQPA/mFv9tGFefjOJVmtVpMpOno5jJ2Hgz625cKllI/tvRP2MdBD379c//z7A072GL6Zmr2+AAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Legends bahvior highlight on hover",
              "title": "Legends bahvior highlight on hover",
              "src": "/static/54d2644a0cec06fc2c1657fac3f55ea7/09548/legends-behavior-1-sm.png",
              "srcSet": ["/static/54d2644a0cec06fc2c1657fac3f55ea7/d6747/legends-behavior-1-sm.png 288w", "/static/54d2644a0cec06fc2c1657fac3f55ea7/09548/legends-behavior-1-sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "47.368421052631575%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABLklEQVQoz51SXUvEMBDs//9lvvggiKAPcnjqidiva5rNxybjJG25KiJoyLBJdjM7yW6TssI5gXcOXiyc94jBAzmjjEz7FzTDh8X97SMOxyOuH55wen3B1c0dDs9vO0L8PPKK3WiCZIgJCKoY/eJ97wZ0/fg/hSkp5tlANe4SZ+4TNCQkzUjpgryTm8s+LSo3X+P5Z33fV2ckydlajDNhCK5T4o0yNS8EinrmfID3sVorfvEXwhAC2rbFQIJushAXsYkNTNDNM4Qxnl9SYEnQnmcmFUwspKEgQzuKXBQO48hAVpeZdVXqo1YbaCdxGEjQF+VW6nl5ou4ggUJ4vylKXMlkDGVr/csYIwJbR+te+VQmYGuldV3Oyp3yui1mWzf7SuKX7pim6WtBvsfkhecTo7/Desx6674AAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Legends bahvior highlight on hover",
              "title": "Legends bahvior highlight on hover",
              "src": "/static/dd72f2c1ccb32a257aad3c8ca1ba9590/fb070/legends-behavior-1.png",
              "srcSet": ["/static/dd72f2c1ccb32a257aad3c8ca1ba9590/d6747/legends-behavior-1.png 288w", "/static/dd72f2c1ccb32a257aad3c8ca1ba9590/09548/legends-behavior-1.png 576w", "/static/dd72f2c1ccb32a257aad3c8ca1ba9590/fb070/legends-behavior-1.png 1152w", "/static/dd72f2c1ccb32a257aad3c8ca1ba9590/fb755/legends-behavior-1.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "47.368421052631575%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABLklEQVQoz51SXUvEMBDs//9lvvggiKAPcnjqidiva5rNxybjJG25KiJoyLBJdjM7yW6TssI5gXcOXiyc94jBAzmjjEz7FzTDh8X97SMOxyOuH55wen3B1c0dDs9vO0L8PPKK3WiCZIgJCKoY/eJ97wZ0/fg/hSkp5tlANe4SZ+4TNCQkzUjpgryTm8s+LSo3X+P5Z33fV2ckydlajDNhCK5T4o0yNS8EinrmfID3sVorfvEXwhAC2rbFQIJushAXsYkNTNDNM4Qxnl9SYEnQnmcmFUwspKEgQzuKXBQO48hAVpeZdVXqo1YbaCdxGEjQF+VW6nl5ou4ggUJ4vylKXMlkDGVr/csYIwJbR+te+VQmYGuldV3Oyp3yui1mWzf7SuKX7pim6WtBvsfkhecTo7/Desx6674AAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Legends bahvior highlight on hover",
              "title": "Legends bahvior highlight on hover",
              "src": "/static/dd72f2c1ccb32a257aad3c8ca1ba9590/fb070/legends-behavior-1.png",
              "srcSet": ["/static/dd72f2c1ccb32a257aad3c8ca1ba9590/d6747/legends-behavior-1.png 288w", "/static/dd72f2c1ccb32a257aad3c8ca1ba9590/09548/legends-behavior-1.png 576w", "/static/dd72f2c1ccb32a257aad3c8ca1ba9590/fb070/legends-behavior-1.png 1152w", "/static/dd72f2c1ccb32a257aad3c8ca1ba9590/fb755/legends-behavior-1.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <h4 {...{
      "id": "click-to-isolate"
    }}>{`Click to isolate`}</h4>
    <p>{`Clicking on the legend of one category isolates the information, hiding all other categories. The legend gets a checkmark on click, switching to a selected state.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAACBUlEQVQ4y51U227iQAzN/3/HPvUveOkDqrZIZRfYIgo02YVASDIhF0LA62NlIickD+1IQ8xcjo/t43Hu9zt9Zwzdc/BTliXleU7n81lmmqaUZRnFcSx2URSynvCMYiPnAahnC/BwONBkMqHxeCxzOp3SYrGg0Wgk9h+2X3l/9vsXvf18IWNiuXy73foZggVAkyQRNpbt6XSStSzLqSoLWvmGnsYr+uvteC9oQtcsBdAYQ/v9nsIwlDDxjaJInMAO2U5NRHM3oB/PK/r42JDrfj7kEraj6V6v1y8VBiE/MNQefN8XhtZbxRdualb1FLuqGiAL3Mqh53mygOp2k20Pd8PT6w+Ay+WyAbTsfGabXy69AJrVAyDCnM1mDSDGZxDQPy7I9ngU8O7FbgQtQEjEdV0BTrjiETPecWUxTrx3ZOlgIG8YBRcP7HHmfbeja73eVBmsttutdEDEBzcsF+sV7DbMUjPD/4CdpJyOmO96rNcWIHQ4n89lcc0eTR22DTVkxggdTFesBMPC1wNMy5plA2hziH4lsOvkBuBIRcqdpDXYm0O02pEZaNl09adDtmB2XwO3hI12g7jtC4M+1q8N2hDO4RQ2vtgzfO5Sy8vRgsVlACZ1VXHIVhYFQ2rs0A0A28rNGXowu12h7fV63YD3Pg7d5PYlW9sIF9EMPl99oEOsh5jb8R/fJxrmt60cpwAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "legends behavior 2",
              "title": "legends behavior 2",
              "src": "/static/5b3872cfcd3d92e5aa6f522cfdc0aba2/09548/legends-behavior-2-sm.png",
              "srcSet": ["/static/5b3872cfcd3d92e5aa6f522cfdc0aba2/d6747/legends-behavior-2-sm.png 288w", "/static/5b3872cfcd3d92e5aa6f522cfdc0aba2/09548/legends-behavior-2-sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "47.368421052631575%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAAA/UlEQVQoz5VRy2rEMAz0//9azz2VpIf0AYFkWb/t2NHOmN3UlKUlgkG2LI9GkiqlSAhBYozivZeUkuQURfZdaDv8GSjnnAzDINM0yTiO8vX5IS+vb/I+fR+EZ0zVWpsqKt22DQxVLi7L1fqm8rRCkmitZQPhwypICwo9xP3+9MwOQs5vWZamhiQad+2DGPgrZlqfEDCWICRDBH3I+adltjvPs1gSAblTygIXzJgfGCd4Zp7FEgmP/w5grCnkdtd1lYBgbW3uzZfu7JFjmnLfCjPW5tEhQynjikrYtrX2WAzRL4qJkUS4t2LwFJKhlu+853u+6gf6lxlj/s3h+w04P8R7biv58QAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "legends behavior 2",
              "title": "legends behavior 2",
              "src": "/static/4af5b25cf2bcf3343065f18d87884be1/fb070/legends-behavior-2.png",
              "srcSet": ["/static/4af5b25cf2bcf3343065f18d87884be1/d6747/legends-behavior-2.png 288w", "/static/4af5b25cf2bcf3343065f18d87884be1/09548/legends-behavior-2.png 576w", "/static/4af5b25cf2bcf3343065f18d87884be1/fb070/legends-behavior-2.png 1152w", "/static/4af5b25cf2bcf3343065f18d87884be1/fb755/legends-behavior-2.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "47.368421052631575%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAAA/UlEQVQoz5VRy2rEMAz0//9azz2VpIf0AYFkWb/t2NHOmN3UlKUlgkG2LI9GkiqlSAhBYozivZeUkuQURfZdaDv8GSjnnAzDINM0yTiO8vX5IS+vb/I+fR+EZ0zVWpsqKt22DQxVLi7L1fqm8rRCkmitZQPhwypICwo9xP3+9MwOQs5vWZamhiQad+2DGPgrZlqfEDCWICRDBH3I+adltjvPs1gSAblTygIXzJgfGCd4Zp7FEgmP/w5grCnkdtd1lYBgbW3uzZfu7JFjmnLfCjPW5tEhQynjikrYtrX2WAzRL4qJkUS4t2LwFJKhlu+853u+6gf6lxlj/s3h+w04P8R7biv58QAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "legends behavior 2",
              "title": "legends behavior 2",
              "src": "/static/4af5b25cf2bcf3343065f18d87884be1/fb070/legends-behavior-2.png",
              "srcSet": ["/static/4af5b25cf2bcf3343065f18d87884be1/d6747/legends-behavior-2.png 288w", "/static/4af5b25cf2bcf3343065f18d87884be1/09548/legends-behavior-2.png 576w", "/static/4af5b25cf2bcf3343065f18d87884be1/fb070/legends-behavior-2.png 1152w", "/static/4af5b25cf2bcf3343065f18d87884be1/fb755/legends-behavior-2.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAACbElEQVQ4y51U23LaMBDl/7+n06c+hMdOwzTpkBDIjAMutcGW78aWbdmnu8Ii4pK2U2YEy0p79ux1MgwD/ufzkd2Ev5qmxeFQoygKlGVJ8gFVVSHLMi1LKbWeD+vattWA9jkDTNMQz4sHzO5nuJ/dY7FYYLVaYTqdYj6fY7Vc4vvDAxZPT/gxmyHLc23c9/1thi9LibtpCH+/RRIn2O12iOMYSZJo1sy2axpsowifHx+x8zxEdG9Ct1lqwPmzxJc7geXrM9brDZbEzvd9RATAoEmaoqBQ38jRJ2Lqrtf4ud1e5ZLlyZ+K8reCccg3GI6KfoAQQiedH5ozgPM0aFmNR8tKnewM8Cnkuq4RBAGMbCc73TdoKnVkrJ0b5jb74RrQdV2t4AJor/ToV5DCd6lVggaZaNC1745k1SFwK5Rpqw/bnAC5ko7jHBnKWv96aQxnI/DqBppBXSjEfo1kL/V9GXVoDj2qXEEe1MhyBOTm5aqWZYEkzOB5OXbcwAkgsgKCHJqQy7hDHNZw3iLs8wyO2EMN/XuVNX2aBAZUXYdIpHhxdhROTYwkhd5jQ8WyC/7t6xbuzwRStUgPFTzq3TNAHikT8ibYo2xrqIYc1cdixHTvEqjIC7yJECIuz2riU5+2Sr3nkEM2gDkZmwTbvdiRQUrvSinPJsTIvV1lDjkeR8m0jX249+yYlTr23alXLeCzSclp6MMwPG0Yrr4txzSG7JBPSmFyi/FdTncNzfqJoQFlY27wYqwqP1JjbviXAcyH35gBYL25m3w0t5f/OSUebZnLlXW1HGzl5aDbMjPgzXPr7mp93QK91P3rFvoNz38WBJ9S6V4AAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "legends behavior 3",
              "title": "legends behavior 3",
              "src": "/static/020e6d2407318ab65a16a20b3b2fc9ce/09548/legends-behavior-3-sm.png",
              "srcSet": ["/static/020e6d2407318ab65a16a20b3b2fc9ce/d6747/legends-behavior-3-sm.png 288w", "/static/020e6d2407318ab65a16a20b3b2fc9ce/09548/legends-behavior-3-sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "47.368421052631575%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABOElEQVQoz5VR20oEMQyd//82Bd9WWVYQXF/csc50ek3b40lnL4OIYiCkuZ2cJkNrBTlFpJQRQqBN9BPQGlQa7X90eD8F3N0/Yr9/wuHwjLfjEQ+7HV5ej98AzzPWOT/kzoA+AKPxZOeRs/SgJVPrXH+vCDfdsrnGNvmh1gLvHWqt18m1VcQgcLMguoIUCopUSK5o9UYxh9qVW0OOhRgE1J0ZY5B8IUuBsQ5mdjidFnySZRYWSkNSYF9pqWy2c4JbMhYfMX64PkxlyDljHEdMBBqN60XatDJtmLzHEnm0Iihk7mLCuw6bPJweU6TnZq5M6zvDaZoQCXzZg35fVb+nNrNpCREzwT1Brjvb7FNKWQGVSSSDxS4oDAqblbUOuvhqIw9VtYnaffZonZz9S/2wPf9vYq39s0bzXwlwwqD7QDXjAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "legends behavior 3",
              "title": "legends behavior 3",
              "src": "/static/0a0a669dfa5f881c47a340e3b948d202/fb070/legends-behavior-3.png",
              "srcSet": ["/static/0a0a669dfa5f881c47a340e3b948d202/d6747/legends-behavior-3.png 288w", "/static/0a0a669dfa5f881c47a340e3b948d202/09548/legends-behavior-3.png 576w", "/static/0a0a669dfa5f881c47a340e3b948d202/fb070/legends-behavior-3.png 1152w", "/static/0a0a669dfa5f881c47a340e3b948d202/fb755/legends-behavior-3.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "47.368421052631575%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABOElEQVQoz5VR20oEMQyd//82Bd9WWVYQXF/csc50ek3b40lnL4OIYiCkuZ2cJkNrBTlFpJQRQqBN9BPQGlQa7X90eD8F3N0/Yr9/wuHwjLfjEQ+7HV5ej98AzzPWOT/kzoA+AKPxZOeRs/SgJVPrXH+vCDfdsrnGNvmh1gLvHWqt18m1VcQgcLMguoIUCopUSK5o9UYxh9qVW0OOhRgE1J0ZY5B8IUuBsQ5mdjidFnySZRYWSkNSYF9pqWy2c4JbMhYfMX64PkxlyDljHEdMBBqN60XatDJtmLzHEnm0Iihk7mLCuw6bPJweU6TnZq5M6zvDaZoQCXzZg35fVb+nNrNpCREzwT1Brjvb7FNKWQGVSSSDxS4oDAqblbUOuvhqIw9VtYnaffZonZz9S/2wPf9vYq39s0bzXwlwwqD7QDXjAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "legends behavior 3",
              "title": "legends behavior 3",
              "src": "/static/0a0a669dfa5f881c47a340e3b948d202/fb070/legends-behavior-3.png",
              "srcSet": ["/static/0a0a669dfa5f881c47a340e3b948d202/d6747/legends-behavior-3.png 288w", "/static/0a0a669dfa5f881c47a340e3b948d202/09548/legends-behavior-3.png 576w", "/static/0a0a669dfa5f881c47a340e3b948d202/fb070/legends-behavior-3.png 1152w", "/static/0a0a669dfa5f881c47a340e3b948d202/fb755/legends-behavior-3.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <p>{`When all categories are selected, checkmarks in legends disappear and the legend resets to its default state.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAACkUlEQVQ4y51UyW7bMBD1/39LTwV66ako2kMcNA5gJzFcL4gVS7YWaqMWSqJeZ6jIlpcAbWnQHA7Jp3mcNxy1bYv/aR+dG/GfUhXyrICU0vQsy5DnOcIoNnZZlse1KI5RVdUR9BLYAIrIx+z5EXd3d7i/H2M6m2G1mGP84xum0xkWiwUmj494eXrC9OEBURR9GKUBfJtnePrpo6w4sgKNyrEUNb5uCqgsRUbR1krBCgJ8nkwQCmEiH0bZgxvA11mK6XcPaRYhDCNkcYgXr8SXZW5sQT5JVFeOg0/jMbzDgXzhVZRsj1p9ctRV/U+J0bq9FSFNdNcDopQkiVnkzXWjadT8bTM2TWM6272/26vPKRdFAdd10dvd5q55rwWSoLqSDPeq1FfZPgJut1vjYLmYDfSznBDePkORNgjsEmlYQTfdwVzWcF9zCKdEeCjRX50BTNMU6/XaODij3OwkxHLjYWm5HWUCklEFf1d0+4IauupAWn0RIUvAoQzKTELsI2xWApYroATg08e8JO3JQuUae0titfZxSGL83u/prptTltngSmDApq7hiBgb14O/LRC7yoDsAv/sDn9N3rCzQyhdISVGzkBCBpBLavVO+dlyMPcoKmK+JYop0Vr6pNOdh4Ub48E6YO5KBMS8opxklK9tEB6jPFLu7zAn2mWtzeaK7sbPG+Qkz7SsYUcSh7S7Q6mIumwgim6PHiaFKQsqp2OWWTYta6sbTUc7EHQ/b8/WukoZlA6L2vM8Sk73wnD2pTzZQoRGYtz5gWBFFLTG55RSpwh7UKbOAufD3bOmTGVw4zF/l1Qvtb4A2N+vjT56MC/nfCW2bZ9V0c3HYei8LPShbR5cksettavSuwV66fub55/bH0+9FTZwm2vDAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "legends behavior 4",
              "title": "legends behavior 4",
              "src": "/static/886fced414c937b970f42d734496dd6c/09548/legends-behavior-4-sm.png",
              "srcSet": ["/static/886fced414c937b970f42d734496dd6c/d6747/legends-behavior-4-sm.png 288w", "/static/886fced414c937b970f42d734496dd6c/09548/legends-behavior-4-sm.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "47.368421052631575%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABVElEQVQoz5VSXU/DMAzs//9v8MYkeECANjapdF3afDpOjks3dWVvRDopsZ3L+eKuVEWMASlGpOCRUoIQtRS0VWv9F7qx93h9ecfnfo+nty98Hw543u1w6vsHQixAxbr+5m6EEir8TFVZYdJShSkEREkbhju2atbYJt+VonDOQlXXl0stCD7DTRnRKa1Q5FyQpaCUu8QUCoSga5CoS65rno3jyETzMsNYh8vkMAwOxnkSKWquEK/LZXFEUlh25Z3A+YTz6KBy9bwTEV4ecGTw0FucLzyPVMR80oIfPjD6ABMFgV0YH/FxnHEcPEyIsElgyXHm46vCizEIDDaChkzYpiIVzGxlJpkh6ck4XgxQWiJa4ajKpSsmdqeNsMmMHBlrLQoVNC9zzvRL0PxtsVquo8XDMk6tpo1ZzrLkW13mJ7Z4t/3+7aoP+3me+Vl1MzIPNbfR+QWos8HAFEZnEwAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "legends behavior 4",
              "title": "legends behavior 4",
              "src": "/static/580033327539fc003fcb79c0d7e97e5a/fb070/legends-behavior-4.png",
              "srcSet": ["/static/580033327539fc003fcb79c0d7e97e5a/d6747/legends-behavior-4.png 288w", "/static/580033327539fc003fcb79c0d7e97e5a/09548/legends-behavior-4.png 576w", "/static/580033327539fc003fcb79c0d7e97e5a/fb070/legends-behavior-4.png 1152w", "/static/580033327539fc003fcb79c0d7e97e5a/fb755/legends-behavior-4.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "47.368421052631575%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABVElEQVQoz5VSXU/DMAzs//9v8MYkeECANjapdF3afDpOjks3dWVvRDopsZ3L+eKuVEWMASlGpOCRUoIQtRS0VWv9F7qx93h9ecfnfo+nty98Hw543u1w6vsHQixAxbr+5m6EEir8TFVZYdJShSkEREkbhju2atbYJt+VonDOQlXXl0stCD7DTRnRKa1Q5FyQpaCUu8QUCoSga5CoS65rno3jyETzMsNYh8vkMAwOxnkSKWquEK/LZXFEUlh25Z3A+YTz6KBy9bwTEV4ecGTw0FucLzyPVMR80oIfPjD6ABMFgV0YH/FxnHEcPEyIsElgyXHm46vCizEIDDaChkzYpiIVzGxlJpkh6ck4XgxQWiJa4ajKpSsmdqeNsMmMHBlrLQoVNC9zzvRL0PxtsVquo8XDMk6tpo1ZzrLkW13mJ7Z4t/3+7aoP+3me+Vl1MzIPNbfR+QWos8HAFEZnEwAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "legends behavior 4",
              "title": "legends behavior 4",
              "src": "/static/580033327539fc003fcb79c0d7e97e5a/fb070/legends-behavior-4.png",
              "srcSet": ["/static/580033327539fc003fcb79c0d7e97e5a/d6747/legends-behavior-4.png 288w", "/static/580033327539fc003fcb79c0d7e97e5a/09548/legends-behavior-4.png 576w", "/static/580033327539fc003fcb79c0d7e97e5a/fb070/legends-behavior-4.png 1152w", "/static/580033327539fc003fcb79c0d7e97e5a/fb755/legends-behavior-4.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
      </Column>
    </Row>
    <h3 {...{
      "id": "hidden-legends"
    }}>{`Hidden legends`}</h3>
    <p>{`Please note that hiding legends is discouraged in data visualizations unless only one category of data is displayed. This design is for mobile displays where offering legends at a glance is less essential. In general, hiding legends reduces the clarity of the visualization and is inaccessible.`}</p>
    <Row mdxType="Row">
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAAC5ElEQVQ4y4VVS08TURi9LowmJBpfG135ByTRhXt+ALCAWAokisrKSKJuoImJRm2MQQ0aF5IYwY2IRMGYiAY0gLzEoBJtoaXl1WdoO6W0nded453pzLTTNnCTmztzv5sz53zf+e4QsKEoCnYaRnync0aMGA+UUiSTSaRSKaTTaXNV48ZUhyzL4HkegiBAkiRtLfygCagGl5aW4Pf7sba2hmWfDyurq1Bo/rBCAS6RRDAQhMfjwdzcHCKRiBVwNykMA+lsVj1l2eezPGKxWElKSOGLKltkkjTGVMabqWkMXu3EYqsTT8/Po8fhweIMt2N+LQxlfXUxSZXtHSC11bh2tgnexttw1v5Ay8kxNB4bxfM2F7Lbsp57pXxRZEq11ReN4kBrK4jNhsfDw+AyGZNNPMSj784yGg6PoLPpD2RJKS/ZkCuwXFU5nSD19fjmcllkFeZ5pCeAcwdHMNS1AlFJQxQka1EMdpOscqSmBo7+/lziRdGaL5qX+MD+G22nJ7HNiXpMyTM0CnFzYACkrg4L6+u5/LCY6jORAWeYdEEUQOUc4NS7CBqOjJpFMvYtgC3d3djT3AyOGdoYGxsbmjfdbjfC4bDpHu/PJOxHRzE9GDEBSxhe6e0FsdsRSCRyMtjMsrwGg0FEWbHULjEkL4zHYWMMf33ZtDLUPKcD9k5MgFRX4+3sjPYuSHJxx0LUK/v+lheXjn9FyJex2EdjSPUKJpjUiosXUOlwmBAi+7JMc1PUWXhSFGeuL+PujUUz1yXGNir9cvw7SPtn2D5sIcnTklZ0xyScehHF3idhzCdk3cN5S5G812Aydc4KIM4ATjyLoGNsC33uDF79TePyJw77H4ZQ8SiEj96sBaxM6ykaqKKajT0P+3lUvd7Evs4QyL0AyP0QDnWFYRuK49+mVBasiGE+KBcc8HESpoMCxn1JrHOCuV8osyxgCSi1thuooF1mKk4hs+Krj5S7yovZqgBUq+buv4P/XrbGnfFV110AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "On mobile, hide legends and reveal on tap",
            "title": "On mobile, hide legends and reveal on tap",
            "src": "/static/3d31ecc060deeaaf1e0fff7f77742e60/c168d/legends-hidden-1.png",
            "srcSet": ["/static/3d31ecc060deeaaf1e0fff7f77742e60/d6747/legends-hidden-1.png 288w", "/static/3d31ecc060deeaaf1e0fff7f77742e60/09548/legends-hidden-1.png 576w", "/static/3d31ecc060deeaaf1e0fff7f77742e60/c168d/legends-hidden-1.png 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  When legends are hidden, a “View legends” button is added so users can surface
  the legend on tap.
        </Caption>
      </Column>
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAAC0ElEQVQ4y41Uy27aQBRl1U0qFapEyq5RP6JSaRASVQPGJgS1y0pJCSbrSm23/b9ESSvxaENoiG1sXiZgXnktTudeM4Q0ocri+Izn3jlz7szoBjRNg0QqlbqH+fhjEFBVFclkkrGxsYF4PI5EIsFMkLF5KIoyw/w8aQVIdWtrC5lMhgWkqOR0Os1xyeRamqCNaSzj7HB7exuHh4fY39/HwcEBisUiSqUSyuUyM/0/hH9jhUIBOzs7CORyOtpuC6VyEZXKCS4uLnBzc4OrqytcX18zX15eLoTMo7Gu6ySYhVltwzFdtDstNJtN2LbN7DgOXNeF53no9/t3QHO9Xo/zWq0W2u22L6jnd/Gn0MRJsQ7DrME4M1Cr1WCaJjMJjkYjDIdDFpEYDAYsXK/XGY1GA/l8HoG93U84sj0U7C5s80wEbRazLIu5Wq3O/klYgjaQgrIiX1DP4Uf1FMXTMzh1ErE4gQQItIBKpzlyQeURd7tddkrzFKd5LjkvPsXjCn6dVGEJJ4ZhsIh0JcVoTDHpvNPpzATvlLy7p8P5WYFVqKDecFiUzo4WU/K8iBSaTCaLS87mdfR+H6MtYIigdEmLpTNaJB1SaXQhBLplyqFcqsQXzOVwbpjoWsK2SKaAFKAybst2+N91uyzmef4tO05jeobTZ5PNZnEuzmIiHuZY3N54POaSCHLMPAXfsBAcDgdc9ng8EjljHueEORZ0xbn0hX35YOfRl9z3cN7z7sU9rz97+CxIDSAajXIziEQiCIfDc3iD9devsB7VEP3cQ+I7sP4NCH99AF+AREacYSwWw+rqKtbW1rCysoJgMIhQKDTFcyw9W8KT5Zd4qh7hxccmljMWgmkboRnqM46pWb8fUl8jp7K/3fa7JN4pCURFm4rEN/FWeQ8l9WEhVC3l98P/dehNMUfQkgmkVAUpLSnmlQVQfYePgthdFRuoqubzQxCxv1GChrpxZktHAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Reveal hidden legends in a modal",
            "title": "Reveal hidden legends in a modal",
            "src": "/static/6c9b5982669f0a6c9940b397952a4b28/c168d/legends-hidden-2.png",
            "srcSet": ["/static/6c9b5982669f0a6c9940b397952a4b28/d6747/legends-hidden-2.png 288w", "/static/6c9b5982669f0a6c9940b397952a4b28/09548/legends-hidden-2.png 576w", "/static/6c9b5982669f0a6c9940b397952a4b28/c168d/legends-hidden-2.png 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  When clicking on “View legends”, a modal with a list of legends appears with
  options to toggle each data category on and off.
        </Caption>
      </Column>
    </Row>
    <h3 {...{
      "id": "legend-overflow"
    }}>{`Legend overflow`}</h3>
    <p>{`Up to two lines of legends are displayed by default. Clicking on `}<strong parentName="p">{`View more`}</strong>{` expands the legend area to show all legends. A legend should not be taller than 30 percent of the chart’s height.`}</p>
    <Row mdxType="Row">
      <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAACcUlEQVQ4y41UyXbbMAz0/39VD7301EP60mxN4tS2rMWSSIqkuGkKKJYtby/l85gLIBAYAFwMw4D/Gax3C5Ocx4L/YorQuoNSCsZoaCVpr0fwWYzxy8umMRpU0uLh4RUvL094W37g5/0zlssl3lcrOntBKwRU3yMGD6SAgRwIIYxIKV16mD+2ePz+AR818kbjx9rCSAGzWqMjD7OqwrdfdyirFptSodjJ8RJJ8D5cGjRZhfz+DySH23UECp2U4+MzpJREg4UlSlqd8FpE3D2trvC7D/lAKsEac6p4yRaBQhziWVI+wcvFMLlLP+fcyMlBmdYne0JKl5k1MsD38RgyC3oinXn5qlzS/hI2zF44G6Ea/xnNsDfIxgST3ElUdYlGttDWwBBCul0ybFMJknOmOZLJQ2st8u0WRduhc1QWQ0BnFISWKPINalGjVu2IzXo1oqdEiY1G3Cm0qwq99ceQre3RNDVlMmBbWZSCOCH5IBz0uoXNG/TbHWxBOg0VfdPi7e4V299vyNcFsq1A8DMOORllWUK0Cs5EtJXB+32Gv4Td+w4yU9CFRl8bJGnQ5x2c8Mg7g1UjULUVfJh7SOVSkEHP9VY1CNsaSVHb0a2ZcjQnKCLfGJorB1H22NkA7T67JO4r4djL1Ku2p+5oJWKtqMzSoe44o8ZFyD6gISMlXZAT+hD38tNHYjFvbE8hpBAvymU+XEjUorP+HW4YTKSkqO2YzwmeMsMlxeC1c34/H8886fF6eiROPOSnioXzLmDD06syfcSG+OwQ2Wy/OH/ProXLc5Zl40Mx1z+nhNeLc+F5n1776NbZwcOvXuJbl10b/wAXAB2gE4A5OQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Legends default to a maximum of two lines. \"View more\" may expand to 30 percent of the chart.",
            "title": "Legends default to a maximum of two lines. \"View more\" may expand to 30 percent of the chart.",
            "src": "/static/362056b765ec978b197ed51e201f462c/c168d/legends-overflow-1a.png",
            "srcSet": ["/static/362056b765ec978b197ed51e201f462c/d6747/legends-overflow-1a.png 288w", "/static/362056b765ec978b197ed51e201f462c/09548/legends-overflow-1a.png 576w", "/static/362056b765ec978b197ed51e201f462c/c168d/legends-overflow-1a.png 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAACsUlEQVQ4y41UbW+bMBDO//9Hk6ZJq/Zh3T6s0tZmbWhTKIQEzIuNsTEYnp1JSEjaqrNyMT6f7+W5x14Mw4D/Gc7uPZn23Vi4P9tb1LVEVVVQqkZdCVrXozidtfbDYNMYHQqh8Hf5CG/1gLUf4NfdA3zfx3MYwvM8FLyEaBp0bYuu686k7/vXGaZeBe86RmcVEq7wI2qgKUsdxailBMsLXN3egpclJK1d5pzzUVoKModk75AyWn7+ikJWKPIcuSjAswzqzx1ylmG19fGy26A1ZszKkJNL6M8yXD1E+HZ1A1GVKLIc1W2AjBxlFEBWCnePV/CerilDypYxJMkWWkkYgsFh3NA8OR0d/k44Pi3XkAVlRxmWzzHSJIEUAl++/0Tk36NIKEhOAXOGbdFiGUgEUUIlG7SU9ZlDQ12W7R70npQWA+FpR4OCcDJdD1dQT3ZOGjqfCwNG1cyKHmFYDNjXblvChjC65NxBQb/+pBv61/zsZxg6kF2p3bFjH5Pc0cUF6cmRyIlObX9y6EBN0xQFNSXjDEKWUI2CMhpCVeOsCBJlGkgifncgugtcF8THqnF4jLWODrV2Dndg3GBD0QrZISsrZHGG9ClEuU2Qb7YoU4Zd8IJwvUa0ChDerJE/bbF5TKBrMyuZsHN0qCkSZwq7UNCBDNEyweaegft0U0h0xNHtJNQLRxqWxM0cASsQpgnBNnOotcaOlJ2o0ZKRZSUs6RqqKdMWeUMz2TNhkTCDODXg1OnuiGl/Tmx3fSoica8MBur2MJJg6s6p4x2JIPCVPVjMOn90OH9+lFZjxx0Eo9C3a5j7dkGdWDdTc5rG2ex1bn96JBbzCIJuRqObs7tpDvfXHZgOtYdXZxrz9eLyPXuL2G6O43gMOLc/I/909S43L1/gtw69pztm+NFL/F6wt8Y/EKsVoVHIlJcAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Legends default to a maximum of two lines. \"View more\" may expand to 30 percent of the chart.",
            "title": "Legends default to a maximum of two lines. \"View more\" may expand to 30 percent of the chart.",
            "src": "/static/65b4b23f15d0e1565b3df172dabfee5e/c168d/legends-overflow-1b.png",
            "srcSet": ["/static/65b4b23f15d0e1565b3df172dabfee5e/d6747/legends-overflow-1b.png 288w", "/static/65b4b23f15d0e1565b3df172dabfee5e/09548/legends-overflow-1b.png 576w", "/static/65b4b23f15d0e1565b3df172dabfee5e/c168d/legends-overflow-1b.png 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <p>{`When legends exceed 30 percent of the chart, overflow the content and scroll vertically.`}</p>
    <Row mdxType="Row">
      <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAAC20lEQVQ4y31UPWgUQRQOWNjZ2IgRRLARewvRKhAr7Q1qRESDghFFIiRWhmihRQSNIIgpLAQrhXBNjCbEmJ8i6qExd7nLxSS3d7nc7u3f7c7OzOfszu4lOXfzjmVv5u28933vfW9aEBgH5xxJ5vuSnsgfWYt0yIVtmzAMA5ZloW6ZsEwTlFLsZs1AWrayAJnMiniyWM7nkc7k8Sebg+U6YMLJGINer8MhDsBokCgRoW+eS5EeWcZmRQWpm5hZq2NtQ4ddWEZlcxM1VcXU4iJ+5IsolnXohhWg4EkBuchYSS9Bq6owBVXTEMFqNdClXFAGXTdAXA9FDfj2cxWux+Mpx21GRn1qW9WC7RhgHhH/2Y5g8Qh9+KJOsknygOcBueIq5idm8H20glLBDPaZ+LkC7XYF7EAYAggdHI6ARatZ3Bt9iz2PB9DX0YX+9jSuHxvHq+4FVBRdICdBIzliAgZZIJH5rrqpYezZAbwaPoeUosIVcnIsioVpFQ/a59DXNgdHDRGypBqGlB1RN+9RCrmHvcJjxta298wchvqXJH0qdRyhbFCOMqlaFWNXB+DNl4M1ISTQIKUimStbNJmxcWSwiHVL1prFUWZhI0Z+fRYft0N1a8FaURSUSiXkhdgLK3+DvaKg3/qyjLG8YMB84Tch5OEk+PYpPYFTd9sCHfqm6zoWhaBzOTE1ti2TmAyHhsr4UvDXBDSOchSwVirj/N59+Prho9wnpFFj15OUU1kdrS/WUbZ5MuVAd4QE76cXO/HkxMlITTvMdhwc7L6DW+9S8ow/04ihLBsjUVpi1LSu26CXrsGbmoWhVOGuVjA+OYv9N2/g+P0emLaxDV2MsBviDN9EE00ZfI71s5fx5ugFvD/cgZ7TV9A5/FoEs+HYdTGa7P/Ri5tJKmbODe9Bt1qDMv0bhYl5kA2tcZDxXS6HpAuTx1yufs2ag8XPctMH26eHCVH7YvPFzxOQRfYPLALpN2VTZHQAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Overflowing legends have vertical scrolling applied.",
            "title": "Overflowing legends have vertical scrolling applied.",
            "src": "/static/9f3d62daa106df1508096f16d55b2a2c/c168d/legends-overflow-2a.png",
            "srcSet": ["/static/9f3d62daa106df1508096f16d55b2a2c/d6747/legends-overflow-2a.png 288w", "/static/9f3d62daa106df1508096f16d55b2a2c/09548/legends-overflow-2a.png 576w", "/static/9f3d62daa106df1508096f16d55b2a2c/c168d/legends-overflow-2a.png 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAACtklEQVQ4y4VVSWsUQRjND/GUH5CL4MGj+APEoxfRgwZEwhhPHjwY0IPkopcgKpiDGKKHgEQjaEhQkhAl+zZLT5aZ6X2ZXqbT67OqeqaddjqToj+quqp4/d73vaoeAGlxHKNfo+udOG//QPcmp+XAtm04jgOH9Dbpo25gxBnwvA+kgGEQgtsroVgsolKpoEyCK5XgaRrCKGTr/dh3xingqeVgd24Ruq7DsiyYJFzDhFetkTkDx0IN+40yA/Z9n0UURT2g/xg6LoT5VYiiCFVVSehQ5Brqxyto6iYkXcbuSRGqokKWFfA8D8MwGGguQ8fzsbjPQZIkaJoKjbBSZQGGyGFj7wCr65sI3FMoikRYeoxhEAQwTZONeyW3bGz//s7YGUYTzaYBQ7PAlwBBlNDgBVi2C06KsVUlIEEilxYuAwiqP3mjlWESOhEEJFeu105/xKpPhKAhSPA8r6c4LId5vup+l3QN1QMORzsGXCKZmSfK2iU3h/97Kwgc/Nz4hKF3ExgrPMX49W2MXVvDn28CfLgENN/wAxlW5ImI52h2hPn3mH05hF+NQwRkLfRDLM+IGL20ROylJEkIc4ydkdqW0uI1qMNvENWlHiOv/FBx6zGHICc9GUC6EMVJ5WbW5vBo8gkb1xp14k0JFY5YiqdygcvTKpaObJoYUA65DOlk2Hb+5MIH3J0YYWNZllEul8FxVXKCTDZ3ZaqJec7sD8hy0gY82drBnQuDkMk5ps21HbRaLhuv13VcfLUNq6056ic5uSQCUId9LDwEd3+UljvdXFEVDD4o4PmXr4kTwrB/UTKL1A7jL2DevIeF4XEs3niGq7dHUJieQkxMzc7weUVJPUXCpWeVsigfYvftLDZff4ZSExNmfpBKPROwiyLSLVHvzdwp3Fk395mSU8ZUWhixvnNV9fsd/AXJTffVuYwsfgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Overflowing legends have vertical scrolling applied.",
            "title": "Overflowing legends have vertical scrolling applied.",
            "src": "/static/37063714566aa4e64c701e179f072e5b/c168d/legends-overflow-2b.png",
            "srcSet": ["/static/37063714566aa4e64c701e179f072e5b/d6747/legends-overflow-2b.png 288w", "/static/37063714566aa4e64c701e179f072e5b/09548/legends-overflow-2b.png 576w", "/static/37063714566aa4e64c701e179f072e5b/c168d/legends-overflow-2b.png 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      